"use client";

import { FC } from "react";
import { useTranslations } from "next-intl";

import { ArticleRecord, IconType } from "@types";

import { ArticleTeaser } from "components/molecules/Teaser/ArticleTeaser";
import { Container } from "components/organisms/Container/Container";
import { Spacer } from "components/organisms/Spacer/Spacer";

import { Button } from "components/atoms/Button/Button";
import { SLUGS } from "consts";

import s from "./RelatedArticlesSection.module.scss";

interface Props {
  articles: ArticleRecord[];
}

export const RelatedArticlesSection: FC<Props> = ({ articles }) => {
  const t = useTranslations("common");

  return (
    <Container>
      <Spacer size="m">
        <h2>{t("news-related")}</h2>
        <div className={s.Related}>
          {articles.map((article) => (
            <div key={article.id}>
              <ArticleTeaser article={article} />
            </div>
          ))}
        </div>
        <Button
          label={t("news-discover")}
          link={{ href: SLUGS.articles }}
          theme="textual"
          icon={IconType.CaretFilled}
        />
      </Spacer>
    </Container>
  );
};
